import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'app-components';

import { ModalContextType } from '../../../contexts/modalContext';
import CapitalizedButton from '../components/common/CapitalizedButton';

interface IModalProps extends ModalContextType {
}

export default function DentalEnrollmentRequirementModal({ closeModal }: IModalProps) {
    
    function onClose(e) {
        e?.preventDefault();
        closeModal('dentalEnrollmentRequirement');
    }

    return (
        <Modal id="dentalEnrollmentRequirementModal">
            <Modal.Header id="dentalEnrollmentRequirementModalHeader" titleId="customGrouping.customGrouping" onHide={onClose} />
            <Modal.Body id="dentalEnrollmentRequirementModalBody">
                <p>
                    <FormattedMessage id="customGrouping.error.dentalNoHealthPlan" />
                </p>
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton 
                    id="dentalEnrollmentRequirementModalShopForHealthButton" 
                    onClickHandler={onClose} 
                    variant="secondary" 
                    labelId="customGrouping.shopForHealth" 
                />
            </Modal.Controls>
        </Modal>
    );
}
